import {
  CARRIER_REQUEST_SUCCESS,
  CARRIER_FETCH,
} from './actionTypes';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case CARRIER_REQUEST_SUCCESS:
      return {
        ...state,
        carrierId: action.carrier.id,
        carrierName: action.carrier.name,
        aqeCarrierId: action.carrier.aqeCarrierId,
      };
    default:
      return state;
  }
}

// actions
export function updateCarrier(carrier) {
  return {
    type: CARRIER_REQUEST_SUCCESS,
    carrier,
  };
}

export function getCarrier(carrierId) {
  return {
    type: CARRIER_FETCH,
    carrierId,
  };
}
